import { api } from './api';
import type {
  NewsArticle,
  NewsDetail,
  NewsEventType,
  NewsPage,
  NewsSource,
} from '../types/News';

interface FetchNewsParams {
  tab: 'trending' | 'latest';
  category?: string;
  sources?: string[];
  page?: number;
  pageSize?: number;
}

export const fetchNews = async ({
  tab,
  category,
  sources,
  page = 1,
  pageSize = 20,
}: FetchNewsParams): Promise<NewsPage> => {
  const params: Record<string, string | number> = { tab, page, page_size: pageSize };
  if (category) params.category = category;
  if (sources && sources.length > 0) params.source = sources.join(',');
  const response = await api.get('/news/', { params });
  return response.data;
};

// ライブラリ/ウィッシュリストのゲームに紐づくニュース（要ログイン）。
// sources は他のタブと同じものを渡すこと（媒体フィルタは全タブ共通の設定なので、
// ここだけ無視すると挙動が食い違う）
export const fetchMyNews = async (
  page = 1,
  pageSize = 20,
  sources?: string[]
): Promise<NewsPage> => {
  const params: Record<string, string | number> = { page, page_size: pageSize };
  if (sources && sources.length > 0) params.source = sources.join(',');
  const response = await api.get('/news/mine/', { params });
  return response.data;
};

export const fetchNewsSources = async (): Promise<NewsSource[]> => {
  const response = await api.get('/news/sources/');
  return response.data.results;
};

export interface RelatedNews {
  game: { game_id: number; name: string; japanese_name: string | null } | null;
  results: NewsArticle[];
}

// 「話題」タブで1件に畳んだクラスタの中身。
// sources は一覧と同じものを渡すこと。揃えないとカードの件数と中身が食い違う
export const fetchRelatedNews = async (
  articleId: number,
  sources?: string[]
): Promise<RelatedNews> => {
  const params = sources && sources.length > 0 ? { source: sources.join(',') } : undefined;
  const response = await api.get(`/news/${articleId}/related/`, { params });
  return response.data;
};

export const fetchGameNews = async (gameId: number): Promise<NewsArticle[]> => {
  const response = await api.get(`/games/${gameId}/news/`);
  return response.data.results;
};

// 計測ビーコン。話題スコアと、画像のホットリンク検証に使う。
// 失敗しても閲覧の邪魔をしないよう握りつぶす
export const sendNewsEvent = (articleId: number, type: NewsEventType): void => {
  api.post(`/news/${articleId}/event/`, { type }).catch(() => {
    /* 計測失敗は無視 */
  });
};

// クッション用の詳細。カバー・機種・ストアリンク・自分のステータスを含む
export const fetchNewsDetail = async (articleId: number): Promise<NewsDetail> => {
  const response = await api.get(`/news/${articleId}/detail/`);
  return response.data;
};
